//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SwoopLogo from '@/components/SwoopLogo'
import SwoopForm from '@/components/SwoopForm'
import {
  AUTH_REQUEST,
  AUTH_FORGOT_PASSWORD_REQUEST,
  AUTH_PASSWORD_RESET_REQUEST
} from '@/store/modules/auth/actions'

export default {
  name: 'Login',
  components: {
    SwoopLogo,
    SwoopForm
  },

  data() {
    return {
      form: null,
      formData: {
        email: '',
        password: '',
        newPassword: ''
      }
    }
  },

  computed: {
    isLogin() {
      return this.$route.path === '/login'
    },
    isForgot() {
      return this.$route.path === '/forgot'
    },
    isReset() {
      return this.$route.path === '/reset'
    }
  },

  watch: {
    $route() {
      // If swapping between /login /forgot /reset routes, update form accordingly.
      this.form.refresh()
      this.form.clearValidation()
      this.form.focus('email')
    }
  },

  methods: {
    fields() {
      return [
        {
          id: 'email',
          label: 'Email',
          type: 'username',
          required: true
        },
        {
          id: 'password',
          label: 'Password',
          type: 'password',
          required: true,
          hidden: () => this.isForgot
        },
        {
          id: 'password_confirmation',
          label: 'Confirm Password',
          type: 'newpassword',
          required: true,
          hidden: () => !this.isReset
        }
      ]
    },

    contactUs() {
      window.location.href = 'mailto:hello@swoop.com.au'
    },

    submit() {
      if (!this.form.focusError()) {
        if (this.isLogin) {
          this.login()
        } else if (this.isForgot) {
          this.forgot()
        } else if (this.isReset) {
          this.reset()
        }
      }
    },

    async login() {
      this.$store
        .dispatch(AUTH_REQUEST, {
          username: this.formData.email,
          password: this.formData.password
        })
        .then(() => {
          if (
            this.$store.getters.isSuperAdmin ||
            this.$store.getters.isMasqueraded
          ) {
            this.$router.push('/')
          } else if (this.$store.getters.isAdmin) {
            this.$router.push('/not-yet')
          } else {
            window.location.href = 'https://my.swoop.com.au/login'
          }
        })
        .catch(error => {
          this.$store.dispatch('notify', {
            message: error.message,
            type: 'negative'
          })
          this.form.focusFirst()
        })
    },

    async forgot() {
      this.$store
        .dispatch(AUTH_FORGOT_PASSWORD_REQUEST, {
          email: this.formData.email
        })
        .then(() => {
          //TODO: test and handle successful request
        })
        .catch(error => {
          this.$store.dispatch('notify', {
            message: error.message,
            type: 'negative'
          })
          this.form.focusFirst()
        })
    },

    async reset() {
      this.$store
        .dispatch(AUTH_PASSWORD_RESET_REQUEST, {
          email: this.formData.email,
          password: this.formData.password,
          password_confirmation: this.formData.password_confirmation,
          token: this.$route.query.token
        })
        .then(() => {
          //TODO: test and handle successful reset
        })
        .catch(error => {
          this.$store.dispatch('notify', {
            message: error.message,
            type: 'negative'
          })
          this.form.focusFirst()
        })
    }
  }
}
